export default {
      id: "ic_waiting_small-usage",
      viewBox: "0 0 16 17",
      url: "/" + "images/icons.3.109.2.svg#ic_waiting_small-usage",
      toString: function () {
        return this.url;
      }
    }